import { checkStatus, getCubeId } from '@/api/login/index'
import VueCookies from 'vue-cookies'
VueCookies.config('90d')

/**
 * lenovo passport 登录后的回调
 * @param commit
 * @param loginSt
 * @param url
 * @return {PromiseLike<T | never> | Promise<T | never> | *}
 * @constructor
 */
export const SetLoginSt = ({ commit }, loginSt, url) => {
  const data = {
    st: loginSt,
    location: url || 'mbgService',
    source: 'pc_web'
  }
  return checkStatus(data).then(res => {
    const loginHash = VueCookies.get('loginHash')
    const lenovoId = res.data.IdentityInfo.AccountID
    const data = {
      lenovo_id: lenovoId,
      login_hash: loginHash,
      token: sessionStorage.getItem('token')
    }
    return getCubeId(data).then(res => {
      sessionStorage.setItem('cube_uid', res.data.cube_uid)
      sessionStorage.setItem('token', res.data.token)
      VueCookies.set('pw_login', 1)
      commit('SET_LOGINST', res)
      return res
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/login/action.js